<template>
  <div class="candidate-tile-conatiner">
    <div class="candidate-tile" @click="openDetails">
      <div class="photo-container">
        <img class="photo" :src="candidatePhoto" alt="candidate.name">
        <div class="listNumber">
          {{ candidate.listNr }}
        </div>
      </div>
      <div class="name">
        {{ candidate.name }}
      </div>
      <div v-if="candidate.additionalInfo != ''" class="additinalInfo">
        {{ candidate.additionalInfo }}
      </div>
      <div class="job">
        {{ candidate.job }}
      </div>
      <div v-if="candidate.expertise != ''" class="additinalInfo">
        <span v-for="(e, idx) in candidate.expertise" :key="e">
        {{ e }}
        <span v-if="idx < (candidate.expertise.length - 1)">,
          
        </span>
        </span>
      </div>
      <div v-if="candidate.quote != ''" class="quote brooks">
        {{ candidate.quote }}
      </div>
      <div class="place">
          Liste 2, Platz {{ candidate.listNr }}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CandidateTile',
  props: {
      candidate: Object,
  },
  methods: {
    openDetails(){
      this.$router.push({name: 'candidate-detail', query: { candidate: this.candidate.listNr}})
    }
  },
  computed: {
    candidatePhoto(){
      return '/img/candidate-photos/' + this.candidate.photo
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.sdglist-container {
  text-align: center;
  position: relative;
  padding-top: 30px;
}

.filter-container {
  position: absolute;
  top: 0px;
  right: 10px;
  font-size: 20px;
}

.candidate-tile {
  background-color: white;
  color: black;
  margin: 10px;
}

.brooks {
  margin: 25px;
  position: relative;
  font-size: 12pt; 
  line-height: 12pt;
  &::before {
    content: '\201C';
    position: absolute;
    top: 0.25em;
    left: -0.35em;
    color: black;
    font-size: 6em;
    z-index: 0;
  }
}

.photo-container{
  position: relative;
  text-align: center;
  color: white;
}

.listNumber{
  position: absolute;
  top: 10;
  left: 10;
}


.name{
  font-size: 18pt;
}

.fav-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  padding-left: 10px;
  padding-top: 10px;
}

.tile {
  height: 30vw;
  width: 30vw;
  max-width: 200px;
  max-height: 200px;
  display: inline-block;
  cursor: pointer;

  @include shadow;
  border-radius: $border-radius;
  margin: 10px;
  overflow: hidden;

  position: relative;

  background-color: white;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}


.photo{
  width: 100%;
}

.favourite {
  color: $green;
}
</style>
